/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BillingContactSummary
 */
export interface BillingContactSummary {
    /**
     * 
     * @type {string}
     * @memberof BillingContactSummary
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingContactSummary
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingContactSummary
     */
    email?: string;
}

/**
 * Check if a given object implements the BillingContactSummary interface.
 */
export function instanceOfBillingContactSummary(value: object): value is BillingContactSummary {
    return true;
}

export function BillingContactSummaryFromJSON(json: any): BillingContactSummary {
    return BillingContactSummaryFromJSONTyped(json, false);
}

export function BillingContactSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingContactSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'email': json['email'] == null ? undefined : json['email'],
    };
}

export function BillingContactSummaryToJSON(value?: BillingContactSummary | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
    };
}

